function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { i18n } from 'invision-core';
import LocaleKeys from '../../../../../locales/keys';
import { getOrderablePricingExtended, goToCheckoutForModify, setSelectedProductId } from '../../../../../reducers/actions/products.order.actions';
import { CurrentCustomerIdSelector } from '../../../../../reducers/selectors/customer.selectors';
import { CurrentSubscriptionIdFromStoreSelector, EditSubscriptionItemIdSelector, IsFetchingDataSelector, IsUpdatingSubscriptionSelector, PricingPlanOptionsSelector, SubscriptionPricingPlanIdSelector, SubscriptionProductIdSelector } from '../../../../../reducers/selectors/customer.subscriptions.selectors';
import { InvalidItemsSelector, OptionalProductsViewModelSelector, OrderablePricingPlansSelector, PicklistProductsViewModelSelector } from '../../../../../reducers/selectors/products.order.selectors';
import { NOTIFICATION_TIME_LENGTH } from '../../../../../customercare.constants';
var ModifyModalController = /*#__PURE__*/function () {
  function ModifyModalController($ngRedux, uiNotificationService) {
    _classCallCheck(this, ModifyModalController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      uiNotificationService: uiNotificationService,
      localeKeys: LocaleKeys,
      shouldShowModal: false
    });
  }
  return _createClass(ModifyModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        getOrderablePricingExtended: getOrderablePricingExtended,
        goToCheckoutForModify: goToCheckoutForModify,
        setSelectedProductId: setSelectedProductId
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentSubscriptionId: CurrentSubscriptionIdFromStoreSelector(store),
          currentSubscriptionItemBeingModifiedId: EditSubscriptionItemIdSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          invalidItems: InvalidItemsSelector(store),
          isFetchingData: IsFetchingDataSelector(store),
          isUpdatingSubscription: IsUpdatingSubscriptionSelector(store),
          optionalProducts: OptionalProductsViewModelSelector(store),
          orderablePlans: OrderablePricingPlansSelector(store),
          pickLists: PicklistProductsViewModelSelector(store),
          subscriptionAvailablePricingPlans: PricingPlanOptionsSelector(store),
          subscriptionPricingPlanId: SubscriptionPricingPlanIdSelector(store),
          subscriptionProductId: SubscriptionProductIdSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.nextStepText = i18n.translate(this.localeKeys.CONTINUE_TO_STEP, {
        step: i18n.translate(this.localeKeys.WIZARD.STEPS.CHECKOUT)
      });
      this.noPlansDialogConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.noPlansDialog = api;
        }
      };
      this.modifyModalConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.modifyModal = api;
        }
      };
      this.actions.setSelectedProductId(this.state.subscriptionProductId);
      this.actions.getOrderablePricingExtended(this.state.subscriptionProductId, this.state.currentCustomerId).then(function () {
        if (_this.hasNoAvailableModifications()) {
          _this.noPlansDialog.open();
        } else {
          _this.modifyModal.open();
        }
      }).catch(function () {
        _this.uiNotificationService.error(i18n.translate(_this.localeKeys.PRODUCTS_ERROR), null, {
          timeOut: NOTIFICATION_TIME_LENGTH
        });
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "handleDialogPopulated",
    value: function handleDialogPopulated() {
      this.modifyModal && this.modifyModal.center();
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.modifyModal.close();
      this.onClose()();
    }
  }, {
    key: "handleFailure",
    value: function handleFailure() {
      var _this2 = this;
      if (this.state.invalidItems.length > 0) {
        this.state.invalidItems.forEach(function (invalidItem) {
          _this2.uiNotificationService.error(invalidItem.productName ? i18n.translate(LocaleKeys.CART.ITEM_NOT_ADDED_NAMED, {
            productName: invalidItem.productName
          }) : i18n.translate(LocaleKeys.CART.ITEM_NOT_ADDED_GENERIC));
        });
      }
    }
  }, {
    key: "handleSuccess",
    value: function handleSuccess() {
      this.actions.setSelectedProductId(null);
      this.actions.goToCheckoutForModify({
        subscriptionId: this.state.currentSubscriptionId,
        childSubscriptionId: this.state.currentSubscriptionItemBeingModifiedId
      });
      this.modifyModal.close();
      this.onSuccess()();
    }
  }, {
    key: "handleConfirmationClose",
    value: function handleConfirmationClose() {
      this.noPlansDialog.close();
      this.onClose()();
    }
  }, {
    key: "hasNoAvailableModifications",
    value: function hasNoAvailableModifications() {
      return this.state.subscriptionAvailablePricingPlans.length <= 1 && !this.state.optionalProducts.length && !this.state.pickLists.length;
    }
  }]);
}();
export default {
  controller: ModifyModalController,
  template: require('./modify.modal.html'),
  bindings: {
    onClose: '&',
    onSuccess: '&'
  }
};